import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import Api from '../server/ModuleApi';

export default {

    importModule: (payload) => {
        const types = {
            request: ActionTypes.MODULE_IMPORT_REQUEST,
            success: [ActionTypes.FORM_SUBMIT_SUCCESS, ActionTypes.MODULE_IMPORT_SUCCESS],
            failure: [ActionTypes.FORM_SUBMIT_ERROR, ActionTypes.MODULE_IMPORT_FAILURE],
        };
        return CentricDispatcher.dispatchAsync(Api.importModule(payload), types, payload);
    },
    emitError: (data) => {
        if (!CentricDispatcher.isDispatching()) {
            return CentricDispatcher.dispatch({type: ActionTypes.FORM_SUBMIT_ERROR, data});
        }
    },
    setTargetFile: (payload) => {
        if (!CentricDispatcher.isDispatching()) {
            return CentricDispatcher.dispatch({type: ActionTypes.MODULE_IMPORT_SET_TARGET_FILE, payload});
        }
    },
    setProcessed: (payload) => {
        if (!CentricDispatcher.isDispatching()) {
            return CentricDispatcher.dispatch({type: ActionTypes.MODULE_IMPORT_SET_PROCESSED, payload});
        }
    }
};
